export default "__VITE_ASSET__21015fb7__"